import {
	fetchServiceInfo,
	fetchTalk,
	fetchOptions,
	fetchFamilyRelations,
} from '@/api/common';

export default {
	async FETCH_SERVICE_INFO({ commit }, payload) {
		const response = await fetchServiceInfo(payload);
		if (response.data.resultCode === 0) {
			commit('FETCH_SERVICE_INFO', response.data.data);
			commit('book/SET_WITH_CALENDAR_YN', response.data.data.driveDates, {
				root: true,
			});
			// commit('book/SET_BOOK_STEPS', response.data.data, { root: true });
			document.title = response.data.data.name;
		}
		return response.data;
	},
	async FETCH_CLAUSE_INFO(_context, payload) {
		const response = await fetchTalk(payload);
		if (response) {
			return response.data.data;
		}
	},
	async FETCH_FAQ_LIST(_context, payload) {
		const response = await fetchTalk(payload);
		if (response) {
			return response.data.data;
		}
	},

	async FETCH_OPTIONS(_context, payload) {
		const response = await fetchOptions(payload);
		if (!response) {
			return;
		}
		return response.data.data;
	},

	async FETCH_FAMILY_RELATIONS() {
		const response = await fetchFamilyRelations();
		if (response) {
			return response.data.data;
		}
	},
};
